import { render, staticRenderFns } from "./CardOwnerCreatorDialog.vue?vue&type=template&id=753e2a88&"
import script from "./CardOwnerCreatorDialog.vue?vue&type=script&lang=js&"
export * from "./CardOwnerCreatorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports